import { addPendingRequest, removePendingRequest } from '../actions/updatePendingRequestActions';
import store from '../store/store';
import { isFeatureEnabled } from 'owa-feature-flags';
import {
    lazyAddPendingRequestCorrelationId,
    lazyRemovePendingRequestCorrelationId,
} from 'owa-readwrite-recipient-well-internal-feedback';
import { orchestrator } from 'satcheljs';

orchestrator(addPendingRequest, actionMessage => {
    store.pendingFindPeopleRequests++;
    if (isFeatureEnabled('rp-findPeopleSuggestionFeedback')) {
        lazyAddPendingRequestCorrelationId.importAndExecute(actionMessage.correlationId);
    }
});

orchestrator(removePendingRequest, actionMessage => {
    store.pendingFindPeopleRequests--;
    if (isFeatureEnabled('rp-findPeopleSuggestionFeedback')) {
        lazyRemovePendingRequestCorrelationId.importAndExecute(actionMessage.correlationId);
    }
});
